import { useEffect, useState } from "react";
import { getPaginatedValidationCrossFieldsList } from "../services/resourcesService";
import { crossFieldValidationsMockData } from "../services/constants/resource";

interface IuseFetchPaginatedCrossFieldValidations {
  currentValidationResultId: any;
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
  page: number;
  pSize: number;
  isDetailedExecutionDataAvailable: boolean;
  queryName: string;
}

const useFetchPaginatedCrossFieldValidations = ({
  currentValidationResultId,
  setIsLoading,
  page,
  pSize,
  isDetailedExecutionDataAvailable,
  queryName,
}: IuseFetchPaginatedCrossFieldValidations) => {
  const [crossFieldValidation, setCrossFieldValidation] = useState<any>([]);
  useEffect(() => {
    if (!isDetailedExecutionDataAvailable) setIsLoading(true);
    const fetchValidationData = async () => {
      try {
        const result = await getPaginatedValidationCrossFieldsList({
          currentValidationResultId,
          page,
          pSize,
          queryName,
        });

        //Set Mock Data
        // const result: any = crossFieldValidationsMockData;
        setCrossFieldValidation(result);
      } catch (err) {
        setCrossFieldValidation([]);
      } finally {
        setIsLoading(false);
      }
    };
    if (!isDetailedExecutionDataAvailable && queryName !== "")
      fetchValidationData();
  }, [
    currentValidationResultId,
    page,
    pSize,
    isDetailedExecutionDataAvailable,
    queryName,
  ]);

  return [crossFieldValidation];
};

export default useFetchPaginatedCrossFieldValidations;
